module.exports = __webpack_public_path__ + "static/media/Postgresql Logo.ea92d658.png";